import { logEvent } from 'firebase/analytics';
import { analytics } from '../backend/firebase';

// Guard: analytics is null in non-browser environments (Jest, SSR)
export const track = (event: string, params?: Record<string, string | number | boolean>) => {
    if (!analytics) return;
    logEvent(analytics, event, params);
};
